<template>
  <div>
    <Header/>

    <b-card class="bCardGlobal">
      <div class="divSubtitulo">
        <b-row>
          <b-col>
            <p class="textoSubtitulo"> CATÁLOGO DE ESCÁNERES </p>
          </b-col>
          <b-col>
            <p class="textoSubtitulo text-right">Catalogo_escaner Lab</p>
          </b-col>
        </b-row>

      </div>

      <div class="d-flex justify-content-center w-100 mt-4">
        <div class="busqueda d-flex mt-4" style="width: 50%; margin-top: 10px;" >
          <b-form-input class="input-filter" v-model="filtroNombreEscaner" placeholder="Búsqueda de escáneres" type="text">
          </b-form-input>
          <b-button class="btn-extra-small" variant="info" style="position: relative; height: 38px; width: 38px;" @click="obtenerListaEscaner()">
            <em class="buscar_svg" style="height: 13px; border-radius: 20px; position: absolute; scale: 2; top: 35%; left: 30%;"></em>
          </b-button>
        </div>
        <div style="margin-left: 6px;">
          <b-button class="rounded-circle btn-dentalia" v-if="$localStorageService.can('escaner_lab_nuevo')">
            <em class="btn-agregar-lab-1" v-b-tooltip.hover.top.v-light title="Crear nuevo escáner"
                @click="abrirModal()">
            </em>
          </b-button>
        </div>
      </div>

      <div class="col-12 mt-5">
        <b-row class="contenedorTablaSinColor">
          <b-col sm="12" md="12" lg="12">
            <b-table
                responsive
                thead-tr-class="columnasTablaSinColor"
                caption-top
                :fields="headersTabla"
                :items="registrosTabla"
            >
              <template v-slot:cell(descargaOdt)="row">
                <span v-if="row.item.descargaOdt">
                  Sí
                </span>
                <span v-else>
                  No
                </span>
              </template>
              <template v-slot:cell(descargaArchivos)="row">
                <span v-if="row.item.descargaArchivos">
                  Sí
                </span>
                <span v-else>
                  No
                </span>
              </template>
              <template #cell(fechaAlta)="row">
                {{ row.item.fechaAlta | formatoFechaCorta }}
              </template>
              <template v-slot:cell(accion)="row">
                <div class="text-center">
                  <!-- Botón Editar o Activar -->

                  <em v-if=" $localStorageService.can('escaner_lab_editar') && row.item.registroActivo"
                      class="edit_outline_svg"
                      style="width: 21px; cursor: pointer"
                      @click="abrirModal(row.item)"
                      v-b-tooltip.hover.topleft.v-light
                      title="Editar">
                  </em>
                  <em v-if="$localStorageService.can('escaner_lab_inactivar') && !row.item.registroActivo"
                      class="activar_kit"
                      style="width: 21px; cursor: pointer"
                      @click="cambiarEstatusEscanerConfirm(row.item)"
                      v-b-tooltip.hover.topright.v-light
                      title="Activar">
                  </em>

                  <!-- Botón Inactivar (sólo visible si tiene permiso y está activo) -->
                  <em v-if="$localStorageService.can('escaner_lab_inactivar') && row.item.registroActivo"
                      class="trash_svg"
                      style="margin-left: 4px; cursor: pointer"
                      v-b-tooltip.hover.topright.v-light
                      title="Inactivar"
                      @click="cambiarEstatusEscanerConfirm(row.item)">
                  </em>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>

    </b-card>

    <b-modal ref="modal-escaner" size="lg" hide-footer hide-header no-close-on-backdrop centered >
      <div class="row">
        <div class="col-10 d-flex" style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%">
          <em class="correoAzul" style="height: 60%; margin-top: 5px"></em>
          <span class="textSize ml-2" style="font-weight: 600;margin-top: 5px;">Nuevo Escáner</span>
        </div>
        <div class="col-2 text-right">
          <button type="button" aria-label="Close" class="close" @click="cerrarModal()">×</button>
        </div>
      </div>

      <b-row>
        <b-col>
          <span class="textForm">Nombre del escáner<span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa el nombre del escáner"
              v-model="datosFormulario.nombreEscaner"
              type="text"
              :state="datosFormulario.nombreEscaner != null && datosFormulario.nombreEscaner !== '' "
              maxlength="100"
              required
          ></b-form-input>
          <br>
          <b-form-checkbox
              id="checkbox-1"
              v-model="datosFormulario.descargaOdt"
              name="descargaOdt"
              true-value="true"
              false-value="false"
          >
            <span class="textForm">¿Descarga ODT? </span>
          </b-form-checkbox>
          <br>
          <b-form-checkbox
              id="checkbox-2"
              v-model="datosFormulario.generaFolio"
              name="generaFolio"
              true-value="true"
              false-value="false"
          >
            <span class="textForm">¿El escáner genera ODT con Folio? </span>
          </b-form-checkbox>
        </b-col>
        <b-col>
          <span class="textForm">Marca del escáner<span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa la marca del escáner"
              v-model="datosFormulario.marcaEscaner"
              type="text"
              :state="datosFormulario.marcaEscaner != null && datosFormulario.marcaEscaner !== '' "
              maxlength="100"
              required
          ></b-form-input>
          <br>
          <b-form-checkbox
              id="checkbox-3"
              v-model="datosFormulario.descargaArchivos"
              name="descargaArchivo"
              true-value="true"
              false-value="false"
          >
            <span class="textForm">¿Descarga archivos adicionales? </span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <div class="m-5 d-flex justify-content-around">
        <b-button variant="primary" class="rounded-pill" :disabled="!formularioValido()"
                  style="background: var(--color-dentalia-1-v2); border-color: var(--color-dentalia-1-v2);"
                  @click="guardarDatos()">
          Guardar
        </b-button>
        <b-button variant="outline-secondary " class="rounded-pill" @click="cerrarModal()">
          Cancelar
        </b-button>
      </div>

    </b-modal>


  </div>
</template>

<script>

import Header from "@/components/Header.vue";

export default {
  name: "CatalogoEscaner",
  components: {
    Header
  },
  props: {

  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    filter: null,
    headersTabla: [
      {key: "idEscaner", label: "Id Laboratorio", sortable: false},
      {key: "nombreEscaner", label: "Nombre", sortable: false},
      {key: "descargaOdt", label: "Descarga ODT", sortable: false},
      {key: "descargaArchivos", label: "Descarga Archivos", sortable: false},
      {key: "fechaAlta", label: "Fecha alta", sortable: false},
      {key: "accion", label: "Acciones"},
    ],

    registrosTabla: [],

    //Formulario de escáner
    datosFormulario : {
      idEscaner: null,
      nombreEscaner: "",
      marcaEscaner: "",
      descargaOdt: false,
      descargaArchivos: false,
      generaFolio: false,
    },
    filtroNombreEscaner: null,

    mostrarModal: false,
  }),
  created() {
    this.obtenerListaEscaner()
  },
  methods: {
    abrirModal(datosEscaner = null) {
      this.$refs['modal-escaner'].show()
      if (datosEscaner) {
        this.datosFormulario = {
          idEscaner: datosEscaner.idEscaner,
          nombreEscaner: datosEscaner.nombreEscaner,
          marcaEscaner: datosEscaner.marcaEscaner,
          descargaOdt: datosEscaner.descargaOdt,
          descargaArchivos: datosEscaner.descargaArchivos,
          generaFolio: datosEscaner.generaFolio,
        };
      }else{
        this.datosFormulario = {
          idEscaner: null,
          nombreEscaner: "",
          marcaEscaner: "",
          descargaOdt: false,
          descargaArchivos: false,
          generaFolio: false,
        };
      }
    },

    cerrarModal() {
      this.$refs['modal-escaner'].hide()
      this.datosFormulario = {
        idEscaner: null,
        nombreEscaner: null,
        marcaEscaner: null,
        descargaOdt: false,
        descargaArchivos: false,
        generaFolio: false,
      };
    },

    guardarDatos() {
      this.$http.post(this.$api + "catalogo/escaner/guardar", this.datosFormulario).then(response => {
        if (response.data.data) {
          this.$swal({
            icon: "success",
            title: "Éxito",
            html: "Escáner guardado correctamente",
          });

          this.cerrarModal();
          this.obtenerListaEscaner();
        }
      }).catch(error => {
        this.$swal({
          icon: "error",
          title: "Error",
          html: error.message,
        });
      })
    },

    cambiarEstatusEscanerConfirm(item) {
      let message = item.registroActivo
          ? `¿Desea desactivar el escáner <strong>${item.nombreEscaner}</strong>?<br><strong>Esta acción afectará a todas las clínicas asociadas.</strong>`
          : `¿Desea activar el escáner <strong>${item.nombreEscaner}</strong>?<br><strong>Esta acción no reactivará la relación con las clínicas.</strong>`;
      this.$swal({
        icon: "warning",
        title: item.registroActivo ? "Desactivar Escáner" : "Activar Escáner",
        html:`${message}` ,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, cancelar",
        confirmButtonColor: "#1b81af",
        cancelButtonColor: "#fff",
        customClass: {
          confirmButton: "rounded-pill text-small",
          cancelButton: " rounded-pill text-small border border-secondary text-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.cambiarEstatus(item);
        }
      });
    },

    cambiarEstatus(item){
      let elementeEliminar = {
        idEscaner: item.idEscaner,
      }
      this.$http.post(this.$api + "catalogo/escaner/cambiarEstatus", elementeEliminar)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Éxito",
              html: item.registroActivo ? `Se ha desactivado correctamente el escáner "${item.nombreEscaner}" ` : `Se ha activado correctamente el escáner "${item.nombreEscaner}" ` ,
            })
            this.obtenerListaEscaner();
          })
          .catch((error) => {
            console.error(error);
            this.$swal({
              icon: "error",
              title: "Error",
              html: item.registroActivo ? `Hubo un error al desactivar el escáner "${item.nombreEscaner}" ` : `Hubo un error al activar el escáner "${item.nombreEscaner}" `,
            })
          }).finally(() =>{});
    },

    obtenerListaEscaner() {
      let filtro = {
        nombreEscaner: this.filtroNombreEscaner,
      }
      this.$http.post(this.$api + "catalogo/escaner/listaEscaner", filtro)
          .then((response) => {
            this.registrosTabla = response.data.data;
          })
          .catch((error) => {
            console.error(error);
            this.$swal({
              icon: "error",
              title: "Error",
              html:`Hubo un error al listar de escáneres ` ,
            })
          }).finally(() =>{});
    },

    formularioValido() {
      return (
          this.datosFormulario.nombreEscaner &&
          this.datosFormulario.nombreEscaner.trim() !== '' &&
          this.datosFormulario.marcaEscaner &&
          this.datosFormulario.marcaEscaner.trim() !== ''
      );
    }
  },
}
</script>

<style scoped>
.busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}
.textSize {
  font-size: 0.8em;
}

.textForm {
  font-size: 10px;
}
.tamanioCampo {
  width: 94%;
}

.btn-agregar-lab-1{
  content: url("../../../assets/laboratorio/escaner 1.svg");
  cursor: pointer;
  position: absolute;
  top: 35%;
  right: 32%;
  scale: 1.7;
}

.btn-dentalia, .btn-dentalia:hover {
  background-color: #1B81AF;
  border-color: #1B81AF;
  color: #fff;
  position: relative;
  width: 45px;
  height: 45px;
  margin-top: 18px;
}


</style>
